import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_HomeroomSetup } from "../shared/data.service";
import { HomeroomUpdateRequest } from "../shared/HomeroomUpdateRequest";

@Component({
	selector: "app-admin-setup-edit-homeroom",
	templateUrl: "./admin-setup-edit-homeroom.component.html",
	styleUrls: ["./admin-setup-edit-homeroom.component.css"],
})
export class AdminSetupEditHomeroomComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private adminSetupService: DataService_HomeroomSetup
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedHomeroom = this.dialogConfig.data.SelectedHomeroom;

		//Get data from DB
		this.loadAcademy();
		this.loadStaff();
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	errorMessage: any = "";

	//Data from parent
	SchoolID: any;
	SelectedHomeroom: any;

	//Select Data
	LoadingAcademy: boolean = false;
	AcademyID: any;
	lstAcademy: any = [];

	SelectedAdmin: any;
	SelectedAdvisor: any;
	LoadingStaff: boolean = false;
	lstStaff: any = [];

	Processing: boolean = false;

	///////////////////////////////////////

	///////////////////////////////////////
	// Load Data
	///////////////////////////////////////
	loadAcademy() {
		this.LoadingAcademy = true;

		var result = this.adminSetupService.LoadAcademy(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				this.AcademyID = -1;
				if (this.lstAcademy.length > 0) {
					this.AcademyID = this.lstAcademy[0].AcademyID;
				}

				for (var z = 0; z < this.lstAcademy.length; z++) {
					var next = this.lstAcademy[z];

					if (next.AcademyID == this.SelectedHomeroom.AcademyID) {
						this.AcademyID = next.AcademyID;
						break;
					}
				}

				this.LoadingAcademy = false;
			},
			(error) => {
				this.LoadingAcademy = false;
			}
		);
	}

	loadStaff() {
		this.LoadingStaff = true;

		var result = this.adminSetupService.LoadStaff(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstStaff = response;

				this.lstStaff.unshift({
					PersonID: -1,
					StaffFullName: "N/A",
				});

				this.SelectedAdmin = this.lstStaff[0];
				this.SelectedAdvisor = this.lstStaff[0];

				if (this.SelectedHomeroom.Administrator_PersonID > 0 || this.SelectedHomeroom.Advisor_PersonID > 0) {
					for (var z = 0; z < this.lstStaff.length; z++) {
						var next = this.lstStaff[z];

						if (next.PersonID == this.SelectedHomeroom.Administrator_PersonID) {
							this.SelectedAdmin = next;
						}
						if (next.PersonID == this.SelectedHomeroom.Advisor_PersonID) {
							this.SelectedAdvisor = next;
						}
					}
				}

				this.LoadingStaff = false;
			},
			(error) => {
				this.LoadingStaff = false;
			}
		);
	}
	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////
	onUpdate() {
		this.Processing = true;

		let parms: HomeroomUpdateRequest = {
			HomeroomID: this.SelectedHomeroom.HomeRoomID,
			Homeroom: this.SelectedHomeroom.Homeroom,
			AcademyID: this.AcademyID,
			Advisor_PersonID: this.SelectedAdvisor.PersonID,
			Administrator_PersonID: this.SelectedAdmin.PersonID,
		};

		var result = this.adminSetupService.HomeroomUpdate(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Homeroom was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Homeroom",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////

	///////////////////////////////////////
	// Helpers
	///////////////////////////////////////

	IsLoading() {
		return this.LoadingAcademy == true || this.LoadingStaff == true || this.Processing == true;
	}

	///////////////////////////////////////
}
